import { Scroll, Preload, ScrollControls, Html } from '@react-three/drei'
import '../styles.css'
import React, {useEffect} from 'react';

export default function BlogPostSIFT() {
    const data = `
    When studying computer vision, you will sooner or later stumble across 
    this algorithm famous for its robustness. Developed by Lowe and published 
    in 2004, Scale-invariant Feature Transform (SIFT) is a well known algorithm 
    for extracting invariant features from images to perform reliable matching. 
    The core idea is to transform image data into scale-invariant coordinates 
    relative to local image features. SIFT is invariant to image scaling, 
    rotation and partially invariant to change in illumination and 3D camera 
    viewpoint. The major stages of computation are:
    \\[x = {-b \\pm \\sqrt{b^2-4ac} \\over 2a}.\\]
    When studying co
    \\(a \\ne 0\\) 
    `;
    
    useEffect(() => {
        if (!window.MathJax) {
            window.MathJax = {
            tex: {
      inlineMath: [["$", "$"]],
      displayMath: [["$$", "$$"]],
            },
            chtml: {
                linebreaks: {
                automatic: true,
                width: "container",
                },
            },
            };
        }

        window.MathJax?.typesetPromise?.();

        const onResize = () => {
            window.MathJax?.typesetClear?.();
            window.MathJax?.typesetPromise?.();
        };

        window.addEventListener("resize", onResize);

        return () => window.removeEventListener("resize", onResize);
    }, []);

    return (    
    <>
    <mesh>
        <boxGeometry args={[1, 1, 1]} />
        <meshStandardMaterial color={'hotpink'} />
    </mesh>
    <Html>
        <div className="row"
            // style={{ 
            //     position: 'absolute', 
            //     top: '10vh', 
            //     left: 0, 
            //     pointerEvents: 'auto', // So it doesn’t interfere with interactions
            //     textAlign: 'left', 
            //     display: 'flex', // Use flexbox for responsive layout
            //     flexDirection: 'column', // Stack items vertically
            //     paddingBottom: '10vh'
            //     }}
        >
            <div className="card">
                <a 
                    style={{ fontSize: '40px', fontWeight: '600'}}
                >
                    DEMYSTIFYING SCALE-INVARIANT FEATURE TRANSFORM
                </a>
                <h5>A gentle introduction to feature detection with Scale-Invariant Feature Transform (SIFT) - the gold standard in terms of robustness</h5>
                <div className="latex-text">
                    <h2>Integrating MathJax v3 in React</h2>
                    {data}
                </div>
                <div style={{ margin: '20px 0', textAlign: 'center' }}>
                <img
                    src="/1d_gaussian.svg"
                    alt="SIFT scale-space illustration"
                    style={{ width: '100%', maxWidth: '700px' }}
                />
                </div>
            </div>
        </div>
    </Html>
    </>
    );
}